export default __webpack_public_path__ + "locales/ro/PortalUnavailable.json?hash=db6926e389c0617556eeaf38606b6864";